import script from "./SpaceduckCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceduckCollapse.vue?vue&type=script&setup=true&lang=js"

import "./SpaceduckCollapse.vue?vue&type=style&index=0&id=4f57189a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f57189a"]])

export default __exports__